import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadRepresentativeByIdBegin,
  loadRepresentativeByIdFailed,
  loadRepresentativeByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadRepresentativeById(action) {
  try {
    const url = `${BACKEND_URL}/v1/attorney-powers/${action.payload}`;
    yield put(loadRepresentativeByIdBegin());
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRepresentativeByIdSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRepresentativeByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadRepresentativeByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
